<template>
  <section class="relative bg-[#F5F5F9] text-[#333] py-20 px-8 md:px-16 animate-fade-in">
    <!-- Ozdobne narożniki -->
    <div class="absolute top-4 left-4">
      <CornerDecoration />
    </div>
    <div class="absolute top-[7px] right-[7px] flex flex-col items-end">
      <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
      <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
    </div>

    <!-- Nagłówek sekcji -->
    <header class="text-center mb-16">
      <h2 class="text-5xl font-bold text-[#222] animate-slide-up">
        Poznaj nas – zespół ProjectSpot z Poznania
      </h2>
      <p class="mt-3 text-lg text-[#555] animate-slide-up delay-200">
        Tworzymy zespół profesjonalistów z pasją do architektury, remontów i projektowania wnętrz.
      </p>
      <div class="w-20 h-[2px] bg-[#E9A53D] mx-auto mt-4"></div>
    </header>

    <!-- Sekcja "Kim jesteśmy" -->
    <section class="grid grid-cols-1 md:grid-cols-12 gap-8 items-center mb-16" aria-label="O firmie ProjectSpot">
      <figure class="md:col-span-5 relative h-[400px] rounded-xl overflow-hidden shadow-lg">
        <img
            src="/images/components/image1.jpg"
            alt="Zespół ProjectSpot – specjaliści od remontów i projektów w Poznaniu"
            class="w-full h-full object-cover"
        />
      </figure>

      <article class="md:col-span-7 text-center md:text-left">
        <h3 class="text-3xl font-semibold text-[#222]">Kim jesteśmy?</h3>
        <div class="w-12 h-[2px] bg-[#E9A53D] my-4 mx-auto md:mx-0"></div>
        <p class="text-[#555] leading-relaxed">
          Jesteśmy zespołem z kilkunastoletnim doświadczeniem w branży budowlanej i projektowej. Łączymy wiedzę techniczną
          z estetyką, by realizować nawet najbardziej wymagające projekty. Nasza siedziba znajduje się w Poznaniu,
          ale działamy na terenie całej Wielkopolski.
        </p>
      </article>
    </section>

    <!-- Sekcja "Czym się zajmujemy" -->
    <section class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" aria-label="Zakres działalności">
      <article class="text-center md:text-left">
        <h3 class="text-3xl font-semibold text-[#222]">
          Czym się zajmujemy? Remonty, wykończenia i architektura
        </h3>
        <div class="w-12 h-[2px] bg-[#E9A53D] my-4 mx-auto md:mx-0"></div>
        <p class="text-[#555] leading-relaxed">
          ProjectSpot to kompleksowe podejście do realizacji projektów budowlanych i wnętrzarskich. Pomagamy na każdym
          etapie: od wyboru działki, przez projekt architektoniczny, po wykończenia pod klucz. Działamy z myślą
          o Twoich potrzebach i komforcie.
        </p>
      </article>

      <figure class="relative h-[400px] rounded-xl overflow-hidden shadow-lg">
        <img
            src="/images/components/image2.jpeg"
            alt="Projektowanie i realizacja prac budowlanych – ProjectSpot, Poznań"
            class="w-full h-full object-cover"
        />
      </figure>
    </section>

    <!-- Sekcja atutów -->
    <section class="mt-16 text-center" aria-label="Nasze atuty">
      <h3 class="text-3xl font-semibold text-[#222]">Nasze atuty</h3>
      <div class="w-12 h-[2px] bg-[#E9A53D] mx-auto my-4"></div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
        <article class="bg-white p-6 rounded-md shadow-sm hover:shadow-xl transition relative">
          <CornerDecoration />
          <h4 class="text-xl font-semibold text-[#222]">KOMPLEKSOWOŚĆ</h4>
          <p class="text-[#555] mt-2">Doradztwo i wsparcie na każdym etapie projektu – od koncepcji po realizację.</p>
        </article>

        <article class="bg-white p-6 rounded-md shadow-sm hover:shadow-xl transition relative">
          <CornerDecoration />
          <h4 class="text-xl font-semibold text-[#222]">WSZECHSTRONNOŚĆ</h4>
          <p class="text-[#555] mt-2">Zespół doświadczonych i wykwalifikowanych specjalistów w wielu dziedzinach budownictwa.</p>
        </article>

        <article class="bg-white p-6 rounded-md shadow-sm hover:shadow-xl transition relative">
          <CornerDecoration />
          <h4 class="text-xl font-semibold text-[#222]">RZETELNOŚĆ</h4>
          <p class="text-[#555] mt-2">Terminowość, transparentność i gwarancja jakości wykonania w każdej realizacji.</p>
        </article>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'AboutSection',
  components: {
    CornerDecoration: {
      template: `
        <div class="absolute top-[0px] left-[0px] flex flex-col">
          <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
          <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
        </div>
        <div class="absolute bottom-[0px] right-[0px] flex flex-col items-end">
          <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
          <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
        </div>
      `
    }
  }
}
</script>

<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fade-in {
  animation: fadeIn 1s ease-out forwards;
}
.animate-slide-up {
  animation: slideUp 0.8s ease-out forwards;
}
.delay-200 {
  animation-delay: 0.2s;
}
</style>
